import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "11",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#DD1F2A",
    d: "M0 10.5h3.1l2-2.5c.4-.5.8-1.1 1.2-1.7h.1c.5.6.9 1.2 1.3 1.7l2 2.5H13L8.3 5.2 12.7 0H9.6L7.8 2.3c-.4.5-.7 1-1.1 1.6h-.1c-.5-.6-.8-1.1-1.2-1.6L3.5 0H.3l4.4 5.1z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h13v10.5H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }